module.exports = __webpack_public_path__ + "static/media/icon-instagram.9d734443.svg";